module.exports = __webpack_public_path__ + "img/banner_en.05000691.png";